export default __webpack_public_path__ + "static/badge_unverified-6068d85a7a05716c65cd85bd714311ab.png";